var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "4"
    }
  }, [_c('iq-card', {
    attrs: {
      "class-name": "iq-user-profile-block1"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function fn() {
        var _vm$user$photo, _vm$user, _vm$user$personal_dat, _vm$user2, _vm$user2$personal_da, _vm$user$personal_dat2, _vm$user3, _vm$user3$personal_da, _vm$user$status_hire, _vm$user4, _vm$user$created_at, _vm$user5, _vm$user$nip, _vm$user6, _vm$user$personal_dat3, _vm$user7, _vm$user7$personal_da, _vm$user$personal_dat4, _vm$user8, _vm$user8$personal_da, _vm$user$personal_dat5, _vm$user9, _vm$user9$personal_da, _vm$user$personal_dat6, _vm$user10, _vm$user10$personal_d, _vm$user10$personal_d2, _vm$user$vehicle$name, _vm$user11, _vm$user11$vehicle, _vm$user$personal_dat7, _vm$user12, _vm$user12$personal_d, _vm$user$personal_dat8, _vm$user13, _vm$user13$personal_d, _vm$user$personal_dat9, _vm$user14, _vm$user14$personal_d, _vm$user15, _vm$user15$personal_d, _vm$user15$personal_d2, _vm$user16, _vm$user16$personal_d, _vm$user16$personal_d2, _vm$user17, _vm$user17$personal_d, _vm$user17$personal_d2, _vm$user$personal_dat10, _vm$user18, _vm$user18$personal_d, _vm$user$personal_dat11, _vm$user19, _vm$user19$personal_d, _vm$user$personal_dat12, _vm$user20, _vm$user20$personal_d, _vm$user$personal_dat13, _vm$user21, _vm$user21$personal_d, _vm$user$personal_dat14, _vm$user22, _vm$user22$personal_d;
        return [_c('div', {
          staticClass: "user-details-block"
        }, [_c('div', {
          staticClass: "user-profile text-center"
        }, [_c('img', {
          staticClass: "avatar-130 img-fluid",
          attrs: {
            "src": (_vm$user$photo = (_vm$user = _vm.user) === null || _vm$user === void 0 ? void 0 : _vm$user.photo) !== null && _vm$user$photo !== void 0 ? _vm$user$photo : _vm.default_photo,
            "alt": "profile-img"
          }
        })]), _c('div', {
          staticClass: "text-center mt-3"
        }, [_c('h4', [_c('b', [_vm._v(_vm._s((_vm$user$personal_dat = (_vm$user2 = _vm.user) === null || _vm$user2 === void 0 ? void 0 : (_vm$user2$personal_da = _vm$user2.personal_data) === null || _vm$user2$personal_da === void 0 ? void 0 : _vm$user2$personal_da.full_name) !== null && _vm$user$personal_dat !== void 0 ? _vm$user$personal_dat : '-'))])]), _c('p', [_vm._v(" " + _vm._s(_vm.countAge) + " Tahun, " + _vm._s((_vm$user$personal_dat2 = (_vm$user3 = _vm.user) === null || _vm$user3 === void 0 ? void 0 : (_vm$user3$personal_da = _vm$user3.personal_data) === null || _vm$user3$personal_da === void 0 ? void 0 : _vm$user3$personal_da.place_of_birth) !== null && _vm$user$personal_dat2 !== void 0 ? _vm$user$personal_dat2 : '-') + " "), _c('br'), _c('b-badge', {
          attrs: {
            "variant": "primary"
          }
        }, [_vm._v(_vm._s((_vm$user$status_hire = (_vm$user4 = _vm.user) === null || _vm$user4 === void 0 ? void 0 : _vm$user4.status_hire) !== null && _vm$user$status_hire !== void 0 ? _vm$user$status_hire : '-') + ", " + _vm._s((_vm$user$created_at = (_vm$user5 = _vm.user) === null || _vm$user5 === void 0 ? void 0 : _vm$user5.created_at) !== null && _vm$user$created_at !== void 0 ? _vm$user$created_at : '-'))])], 1)])]), _c('b-alert', {
          staticClass: "text-center text-white bg-primary",
          attrs: {
            "show": true
          }
        }, [_c('div', {
          staticClass: "iq-alert-text"
        }, [_c('strong', [_vm._v("DATA DIRI")])])]), _c('table', {
          staticClass: "table table-striped"
        }, [_c('tbody', [_c('tr', [_c('td', [_c('strong', [_vm._v("Nomor Pegawai")])]), _c('td', [_vm._v(_vm._s((_vm$user$nip = (_vm$user6 = _vm.user) === null || _vm$user6 === void 0 ? void 0 : _vm$user6.nip) !== null && _vm$user$nip !== void 0 ? _vm$user$nip : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Nomor KTP")])]), _c('td', [_vm._v(_vm._s((_vm$user$personal_dat3 = (_vm$user7 = _vm.user) === null || _vm$user7 === void 0 ? void 0 : (_vm$user7$personal_da = _vm$user7.personal_data) === null || _vm$user7$personal_da === void 0 ? void 0 : _vm$user7$personal_da.nik_ktp) !== null && _vm$user$personal_dat3 !== void 0 ? _vm$user$personal_dat3 : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Seaferer Code")])]), _c('td', [_vm._v(_vm._s((_vm$user$personal_dat4 = (_vm$user8 = _vm.user) === null || _vm$user8 === void 0 ? void 0 : (_vm$user8$personal_da = _vm$user8.personal_data) === null || _vm$user8$personal_da === void 0 ? void 0 : _vm$user8$personal_da.seaferer_code) !== null && _vm$user$personal_dat4 !== void 0 ? _vm$user$personal_dat4 : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Nomor NPWP")])]), _c('td', [_vm._v(_vm._s((_vm$user$personal_dat5 = (_vm$user9 = _vm.user) === null || _vm$user9 === void 0 ? void 0 : (_vm$user9$personal_da = _vm$user9.personal_data) === null || _vm$user9$personal_da === void 0 ? void 0 : _vm$user9$personal_da.npwp_number) !== null && _vm$user$personal_dat5 !== void 0 ? _vm$user$personal_dat5 : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Jabatan/Ijazah")])]), _c('td', [_vm._v(_vm._s((_vm$user$personal_dat6 = (_vm$user10 = _vm.user) === null || _vm$user10 === void 0 ? void 0 : (_vm$user10$personal_d = _vm$user10.personal_data) === null || _vm$user10$personal_d === void 0 ? void 0 : (_vm$user10$personal_d2 = _vm$user10$personal_d.position) === null || _vm$user10$personal_d2 === void 0 ? void 0 : _vm$user10$personal_d2.name) !== null && _vm$user$personal_dat6 !== void 0 ? _vm$user$personal_dat6 : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Fleet")])]), _c('td', [_vm._v(_vm._s((_vm$user$vehicle$name = (_vm$user11 = _vm.user) === null || _vm$user11 === void 0 ? void 0 : (_vm$user11$vehicle = _vm$user11.vehicle) === null || _vm$user11$vehicle === void 0 ? void 0 : _vm$user11$vehicle.name) !== null && _vm$user$vehicle$name !== void 0 ? _vm$user$vehicle$name : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Kewarganegaraan")])]), _c('td', [_vm._v(_vm._s((_vm$user$personal_dat7 = (_vm$user12 = _vm.user) === null || _vm$user12 === void 0 ? void 0 : (_vm$user12$personal_d = _vm$user12.personal_data) === null || _vm$user12$personal_d === void 0 ? void 0 : _vm$user12$personal_d.citizenship) !== null && _vm$user$personal_dat7 !== void 0 ? _vm$user$personal_dat7 : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Tempat/Tanggal Lahir")])]), _c('td', [_vm._v(" " + _vm._s((_vm$user$personal_dat8 = (_vm$user13 = _vm.user) === null || _vm$user13 === void 0 ? void 0 : (_vm$user13$personal_d = _vm$user13.personal_data) === null || _vm$user13$personal_d === void 0 ? void 0 : _vm$user13$personal_d.place_of_birth) !== null && _vm$user$personal_dat8 !== void 0 ? _vm$user$personal_dat8 : '-') + " / " + _vm._s((_vm$user$personal_dat9 = (_vm$user14 = _vm.user) === null || _vm$user14 === void 0 ? void 0 : (_vm$user14$personal_d = _vm$user14.personal_data) === null || _vm$user14$personal_d === void 0 ? void 0 : _vm$user14$personal_d.date_of_birth) !== null && _vm$user$personal_dat9 !== void 0 ? _vm$user$personal_dat9 : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Golongan Darah")])]), _c('td', [_vm._v(_vm._s((_vm$user15 = _vm.user) === null || _vm$user15 === void 0 ? void 0 : (_vm$user15$personal_d = _vm$user15.personal_data) === null || _vm$user15$personal_d === void 0 ? void 0 : (_vm$user15$personal_d2 = _vm$user15$personal_d.blood_type) === null || _vm$user15$personal_d2 === void 0 ? void 0 : _vm$user15$personal_d2.alias))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Agama")])]), _c('td', [_vm._v(_vm._s((_vm$user16 = _vm.user) === null || _vm$user16 === void 0 ? void 0 : (_vm$user16$personal_d = _vm$user16.personal_data) === null || _vm$user16$personal_d === void 0 ? void 0 : (_vm$user16$personal_d2 = _vm$user16$personal_d.religion) === null || _vm$user16$personal_d2 === void 0 ? void 0 : _vm$user16$personal_d2.name))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Status")])]), _c('td', [_vm._v(_vm._s((_vm$user17 = _vm.user) === null || _vm$user17 === void 0 ? void 0 : (_vm$user17$personal_d = _vm$user17.personal_data) === null || _vm$user17$personal_d === void 0 ? void 0 : (_vm$user17$personal_d2 = _vm$user17$personal_d.marital_status) === null || _vm$user17$personal_d2 === void 0 ? void 0 : _vm$user17$personal_d2.name))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Anak Sendiri")])]), _c('td', [_vm._v(_vm._s((_vm$user$personal_dat10 = (_vm$user18 = _vm.user) === null || _vm$user18 === void 0 ? void 0 : (_vm$user18$personal_d = _vm$user18.personal_data) === null || _vm$user18$personal_d === void 0 ? void 0 : _vm$user18$personal_d.number_of_children) !== null && _vm$user$personal_dat10 !== void 0 ? _vm$user$personal_dat10 : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Nomor Tlp./HP")])]), _c('td', [_vm._v(_vm._s((_vm$user$personal_dat11 = (_vm$user19 = _vm.user) === null || _vm$user19 === void 0 ? void 0 : (_vm$user19$personal_d = _vm$user19.personal_data) === null || _vm$user19$personal_d === void 0 ? void 0 : _vm$user19$personal_d.hp_number) !== null && _vm$user$personal_dat11 !== void 0 ? _vm$user$personal_dat11 : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Email")])]), _c('td', [_vm._v(_vm._s((_vm$user$personal_dat12 = (_vm$user20 = _vm.user) === null || _vm$user20 === void 0 ? void 0 : (_vm$user20$personal_d = _vm$user20.personal_data) === null || _vm$user20$personal_d === void 0 ? void 0 : _vm$user20$personal_d.email) !== null && _vm$user$personal_dat12 !== void 0 ? _vm$user$personal_dat12 : '-'))])]), _c('tr', [_c('td', {
          attrs: {
            "colspan": "2"
          }
        }, [_c('strong', [_vm._v("Alamat KTP")])])]), _c('tr', [_c('td', {
          attrs: {
            "colspan": "2"
          }
        }, [_vm._v(" " + _vm._s((_vm$user$personal_dat13 = (_vm$user21 = _vm.user) === null || _vm$user21 === void 0 ? void 0 : (_vm$user21$personal_d = _vm$user21.personal_data) === null || _vm$user21$personal_d === void 0 ? void 0 : _vm$user21$personal_d.address_of_ktp) !== null && _vm$user$personal_dat13 !== void 0 ? _vm$user$personal_dat13 : '-') + " ")])]), _c('tr', [_c('td', {
          attrs: {
            "colspan": "2"
          }
        }, [_c('strong', [_vm._v("Alamat Domisili")])])]), _c('tr', [_c('td', {
          attrs: {
            "colspan": "2"
          }
        }, [_vm._v(" " + _vm._s((_vm$user$personal_dat14 = (_vm$user22 = _vm.user) === null || _vm$user22 === void 0 ? void 0 : (_vm$user22$personal_d = _vm$user22.personal_data) === null || _vm$user22$personal_d === void 0 ? void 0 : _vm$user22$personal_d.address_of_domisili) !== null && _vm$user$personal_dat14 !== void 0 ? _vm$user$personal_dat14 : '-') + " ")])])])])];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "body",
      fn: function fn() {
        return [_c('table', {
          staticClass: "table table-striped"
        }, [_c('tbody', [_c('tr', {
          staticClass: "bg-info"
        }, [_c('td', {
          staticClass: "text-center",
          attrs: {
            "colspan": "2"
          }
        }, [_c('strong', [_vm._v("JOIN DATE")])])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Sign On")])]), _c('td', [_vm._v("01 January 2020")])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Sign Off")])]), _c('td', [_vm._v("01 January 2025")])])])])];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "body",
      fn: function fn() {
        var _vm$user$personal_dat15, _vm$user23, _vm$user23$personal_d, _vm$user$personal_dat16, _vm$user24, _vm$user24$personal_d, _vm$user$personal_dat17, _vm$user25, _vm$user25$personal_d;
        return [_c('table', {
          staticClass: "table table-striped"
        }, [_c('tbody', [_c('tr', {
          staticClass: "bg-info"
        }, [_c('td', {
          staticClass: "text-center",
          attrs: {
            "colspan": "2"
          }
        }, [_c('strong', [_vm._v("PAKAIAN & SEPATU")])])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Tinggi Badan")])]), _c('td', [_vm._v("N/A CM")])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Berat Badan")])]), _c('td', [_vm._v(_vm._s((_vm$user$personal_dat15 = (_vm$user23 = _vm.user) === null || _vm$user23 === void 0 ? void 0 : (_vm$user23$personal_d = _vm$user23.personal_data) === null || _vm$user23$personal_d === void 0 ? void 0 : _vm$user23$personal_d.weight) !== null && _vm$user$personal_dat15 !== void 0 ? _vm$user$personal_dat15 : '-') + " KG")])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Wearpack")])]), _c('td', [_vm._v(_vm._s((_vm$user$personal_dat16 = (_vm$user24 = _vm.user) === null || _vm$user24 === void 0 ? void 0 : (_vm$user24$personal_d = _vm$user24.personal_data) === null || _vm$user24$personal_d === void 0 ? void 0 : _vm$user24$personal_d.wearpack) !== null && _vm$user$personal_dat16 !== void 0 ? _vm$user$personal_dat16 : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Sepatu")])]), _c('td', [_vm._v(_vm._s((_vm$user$personal_dat17 = (_vm$user25 = _vm.user) === null || _vm$user25 === void 0 ? void 0 : (_vm$user25$personal_d = _vm$user25.personal_data) === null || _vm$user25$personal_d === void 0 ? void 0 : _vm$user25$personal_d.size_of_shoes) !== null && _vm$user$personal_dat17 !== void 0 ? _vm$user$personal_dat17 : '-'))])])])])];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "body",
      fn: function fn() {
        var _vm$user$personal_dat18, _vm$user26, _vm$user26$personal_d, _vm$user$personal_dat19, _vm$user27, _vm$user27$personal_d, _vm$user$personal_dat20, _vm$user28, _vm$user28$personal_d, _vm$user$personal_dat21, _vm$user29, _vm$user29$personal_d;
        return [_c('table', {
          staticClass: "table table-striped"
        }, [_c('tbody', [_c('tr', {
          staticClass: "bg-info"
        }, [_c('td', {
          staticClass: "text-center",
          attrs: {
            "colspan": "2"
          }
        }, [_c('strong', [_vm._v("EMERGENCY CALL")])])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Nama Lengkap")])]), _c('td', [_vm._v(_vm._s((_vm$user$personal_dat18 = (_vm$user26 = _vm.user) === null || _vm$user26 === void 0 ? void 0 : (_vm$user26$personal_d = _vm$user26.personal_data) === null || _vm$user26$personal_d === void 0 ? void 0 : _vm$user26$personal_d.family_emergency_name) !== null && _vm$user$personal_dat18 !== void 0 ? _vm$user$personal_dat18 : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("No. Tlp/HP")])]), _c('td', [_vm._v(_vm._s((_vm$user$personal_dat19 = (_vm$user27 = _vm.user) === null || _vm$user27 === void 0 ? void 0 : (_vm$user27$personal_d = _vm$user27.personal_data) === null || _vm$user27$personal_d === void 0 ? void 0 : _vm$user27$personal_d.emergency_number) !== null && _vm$user$personal_dat19 !== void 0 ? _vm$user$personal_dat19 : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Hubungan")])]), _c('td', [_vm._v(_vm._s((_vm$user$personal_dat20 = (_vm$user28 = _vm.user) === null || _vm$user28 === void 0 ? void 0 : (_vm$user28$personal_d = _vm$user28.personal_data) === null || _vm$user28$personal_d === void 0 ? void 0 : _vm$user28$personal_d.family_emergency_status) !== null && _vm$user$personal_dat20 !== void 0 ? _vm$user$personal_dat20 : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("alamat")])]), _c('td', {
          attrs: {
            "colspan": "2"
          }
        }, [_vm._v(" " + _vm._s((_vm$user$personal_dat21 = (_vm$user29 = _vm.user) === null || _vm$user29 === void 0 ? void 0 : (_vm$user29$personal_d = _vm$user29.personal_data) === null || _vm$user29$personal_d === void 0 ? void 0 : _vm$user29$personal_d.family_emergency_address) !== null && _vm$user$personal_dat21 !== void 0 ? _vm$user$personal_dat21 : '-') + " ")])])])])];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "body",
      fn: function fn() {
        return [_c('table', {
          staticClass: "table table-striped"
        }, [_c('tbody', [_c('tr', {
          staticClass: "bg-info"
        }, [_c('td', {
          staticClass: "text-center",
          attrs: {
            "colspan": "2"
          }
        }, [_c('strong', [_vm._v("VERIFICATION DOCUMENT")])])]), _c('tr', [_c('td', {
          attrs: {
            "width": "90%"
          }
        }, [_c('strong', [_vm._v("CURRICULUM VITAE")])]), _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('i', {
          staticClass: "fa fa-check mr-3 text-primary"
        })])]), _c('tr', [_c('td', {
          attrs: {
            "width": "90%"
          }
        }, [_c('strong', [_vm._v("CERTIFICATE OF COMPETENCY")])]), _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('i', {
          staticClass: "fa fa-check mr-3 text-primary"
        })])]), _c('tr', [_c('td', {
          attrs: {
            "width": "90%"
          }
        }, [_c('strong', [_vm._v("CERTIFICATE OF PROFICIENCY (BST, PSCRB, AFF, MFA, ETC)")])]), _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('i', {
          staticClass: "fa fa-check mr-3 text-primary"
        })])]), _c('tr', [_c('td', {
          attrs: {
            "width": "90%"
          }
        }, [_c('strong', [_vm._v("ORU / GOC (IF ANY)")])]), _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('i', {
          staticClass: "fa fa-check mr-3 text-primary"
        })])]), _c('tr', [_c('td', {
          attrs: {
            "width": "90%"
          }
        }, [_c('strong', [_vm._v("SEAMAN BOOK")])]), _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('i', {
          staticClass: "fa fa-check mr-3 text-primary"
        })])]), _c('tr', [_c('td', {
          attrs: {
            "width": "90%"
          }
        }, [_c('strong', [_vm._v("PASSPORT")])]), _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('i', {
          staticClass: "fa fa-check mr-3 text-primary"
        })])]), _c('tr', [_c('td', {
          attrs: {
            "width": "90%"
          }
        }, [_c('strong', [_vm._v("MCU")])]), _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('i', {
          staticClass: "fa fa-check mr-3 text-primary"
        })])]), _c('tr', [_c('td', {
          attrs: {
            "width": "90%"
          }
        }, [_c('strong', [_vm._v("KTP")])]), _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('i', {
          staticClass: "fa fa-check mr-3 text-primary"
        })])]), _c('tr', [_c('td', {
          attrs: {
            "width": "90%"
          }
        }, [_c('strong', [_vm._v("KARTU KELUARGA, NPWP")])]), _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('i', {
          staticClass: "fa fa-check mr-3 text-primary"
        })])]), _c('tr', [_c('td', {
          attrs: {
            "width": "90%"
          }
        }, [_c('strong', [_vm._v("PHOTOGRAPH")])]), _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('i', {
          staticClass: "fa fa-check mr-3 text-primary"
        })])]), _c('tr', [_c('td', {
          attrs: {
            "width": "90%"
          }
        }, [_c('strong', [_vm._v("FORM INTERVIEW")])]), _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('i', {
          staticClass: "fa fa-check mr-3 text-primary"
        })])]), _c('tr', [_c('td', {
          attrs: {
            "width": "90%"
          }
        }, [_c('strong', [_vm._v("FORM INDUCTION")])]), _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('i', {
          staticClass: "fa fa-check mr-3 text-primary"
        })])]), _c('tr', [_c('td', {
          attrs: {
            "width": "90%"
          }
        }, [_c('strong', [_vm._v("COPY PKL, PAKTA INTEGRITAS, SURAT MUTASI ON")])]), _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('i', {
          staticClass: "fa fa-check mr-3 text-primary"
        })])]), _c('tr', [_c('td', {
          attrs: {
            "width": "90%"
          }
        }, [_c('strong', [_vm._v("BUKU REKENING")])]), _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('i', {
          staticClass: "fa fa-check mr-3 text-primary"
        })])]), _c('tr', [_c('td', {
          attrs: {
            "width": "90%"
          }
        }, [_c('strong', [_vm._v("EMBARKING TICKET (IF ANY)")])]), _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('i', {
          staticClass: "fa fa-check mr-3 text-primary"
        })])])])])];
      },
      proxy: true
    }])
  })], 1), _c('b-col', {
    attrs: {
      "lg": "8"
    }
  }, [_vm._l(_vm.charts, function (item, index) {
    return _c('iq-card', {
      key: index,
      scopedSlots: _vm._u([{
        key: "headerTitle",
        fn: function fn() {
          return [_c('h4', [_vm._v(_vm._s(item.title))])];
        },
        proxy: true
      }, {
        key: "body",
        fn: function fn() {
          return [_c('ApexChart', {
            attrs: {
              "element": item.type,
              "chartOption": item.bodyData
            }
          })];
        },
        proxy: true
      }], null, true)
    });
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_vm._v("PENDIDIKAN")])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$user30;
        return [_c('table', {
          staticClass: "table table-striped mb-0"
        }, [_c('thead', [_c('tr', [_c('th', {
          staticClass: "align-middle text-center"
        }, [_vm._v("Sekolah/Universitas")]), _c('th', {
          staticClass: "align-middle text-center"
        }, [_vm._v("Jenjang")]), _c('th', {
          staticClass: "align-middle text-center"
        }, [_vm._v("Jurusan")]), _c('th', {
          staticClass: "align-middle text-center"
        }, [_vm._v("IPK/Nilai Akhir")]), _c('th', {
          staticClass: "align-middle text-center"
        }, [_vm._v("Tahun Mulai")]), _c('th', {
          staticClass: "align-middle text-center"
        }, [_vm._v("Tahun Selesai")]), _c('th', {
          staticClass: "align-middle text-center"
        }, [_vm._v("Kota/Negara")])])]), _c('tbody', _vm._l((_vm$user30 = _vm.user) === null || _vm$user30 === void 0 ? void 0 : _vm$user30.education, function (state, index) {
          var _state$sekolah, _state$jenjang, _state$jurusan, _state$nilai, _state$tahun_mulai, _state$tahun_selesai;
          return _c('tr', {
            key: index
          }, [_c('td', [_vm._v(_vm._s((_state$sekolah = state === null || state === void 0 ? void 0 : state.sekolah) !== null && _state$sekolah !== void 0 ? _state$sekolah : '-'))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s((_state$jenjang = state === null || state === void 0 ? void 0 : state.jenjang) !== null && _state$jenjang !== void 0 ? _state$jenjang : '-'))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s((_state$jurusan = state === null || state === void 0 ? void 0 : state.jurusan) !== null && _state$jurusan !== void 0 ? _state$jurusan : '-'))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s((_state$nilai = state === null || state === void 0 ? void 0 : state.nilai) !== null && _state$nilai !== void 0 ? _state$nilai : '-'))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s((_state$tahun_mulai = state === null || state === void 0 ? void 0 : state.tahun_mulai) !== null && _state$tahun_mulai !== void 0 ? _state$tahun_mulai : '-'))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s((_state$tahun_selesai = state === null || state === void 0 ? void 0 : state.tahun_selesai) !== null && _state$tahun_selesai !== void 0 ? _state$tahun_selesai : '-'))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.kota) + " / " + _vm._s(state === null || state === void 0 ? void 0 : state.negara))])]);
        }), 0)])];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_vm._v("DATA KELUARGA")])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$user31;
        return [_c('table', {
          staticClass: "table table-striped mb-0"
        }, [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-center"
        }, [_vm._v("No")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Nama Lengkap")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Hubungan")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Jenis Kelamin")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Umur")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Pekerjaan")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("No.Hp")])])]), _c('tbody', _vm._l((_vm$user31 = _vm.user) === null || _vm$user31 === void 0 ? void 0 : _vm$user31.family, function (state, index) {
          return _c('tr', {
            key: index
          }, [_c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(index + 1))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.nama_lengkap))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.status))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.jenis_kelamin))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.age_family))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.pekerjaan))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.no_hp))])]);
        }), 0)])];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_vm._v("TRAVEL DOCUMENT")])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$user32;
        return [_c('table', {
          staticClass: "table table-striped mb-0"
        }, [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-center"
        }, [_vm._v("No")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Nama Document")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("No Dokument")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Place & Date Issued")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Masa Berlaku")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("File")])])]), _c('tbody', _vm._l((_vm$user32 = _vm.user) === null || _vm$user32 === void 0 ? void 0 : _vm$user32.travel_document, function (state, index) {
          return _c('tr', {
            key: index
          }, [_c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(index + 1))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.document_name))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.document_number))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.date_issued + ', ' + state.place_issued))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.validity_period))]), state.file ? _c('td', {
            staticClass: "text-center"
          }, [_c('i', {
            staticClass: "fa fa-file-alt text-primary"
          })]) : _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s('-'))])]);
        }), 0)])];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_vm._v("CERTIFICATE OF COMPETENCY")])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$user33;
        return [_c('table', {
          staticClass: "table table-striped mb-0"
        }, [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-center"
        }, [_vm._v("No")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Ijazah & Endorse")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Nomor Sertifikat")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Place & Date Issued")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Masa Berlaku")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("File")])])]), _c('tbody', _vm._l((_vm$user33 = _vm.user) === null || _vm$user33 === void 0 ? void 0 : _vm$user33.certificate_of_competency, function (state, index) {
          return _c('tr', {
            key: index
          }, [_c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(index + 1))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.document_name))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.document_number))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.date_issued + ', ' + state.place_issued))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.validity_period))]), state.file ? _c('td', {
            staticClass: "text-center"
          }, [_c('i', {
            staticClass: "fa fa-file-alt text-primary"
          })]) : _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s('-'))])]);
        }), 0)])];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_vm._v("CERTIFICATE OF PROFICIENCY")])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$user34;
        return [_c('table', {
          staticClass: "table table-striped mb-0"
        }, [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-center"
        }, [_vm._v("No")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Nama Sertifikat")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Nomor Sertifikat")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Place & Date Issued")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Masa Berlaku")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("File")])])]), _c('tbody', _vm._l((_vm$user34 = _vm.user) === null || _vm$user34 === void 0 ? void 0 : _vm$user34.certificate_of_proficiency, function (state, index) {
          return _c('tr', {
            key: index
          }, [_c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(index + 1))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.document_name))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.document_number))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.date_issued + ', ' + state.place_issued))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.validity_period))]), state.file ? _c('td', {
            staticClass: "text-center"
          }, [_c('i', {
            staticClass: "fa fa-file-alt text-primary"
          })]) : _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s('-'))])]);
        }), 0)])];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_vm._v("PENGALAMAN BERLAYAR, MINIMAL 5 PENGALAMAN TERAKHIR")])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$user35;
        return [_c('table', {
          staticClass: "table table-striped mb-0"
        }, [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-center align-middle",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("No")]), _c('th', {
          staticClass: "text-center align-middle",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("Kapal / Pemilik")]), _c('th', {
          staticClass: "text-center align-middle",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("Bendera / Kawasan")]), _c('th', {
          staticClass: "text-center align-middle",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("Jabatan")]), _c('th', {
          staticClass: "text-center align-middle",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("Telp./HP")]), _c('th', {
          staticClass: "text-center align-middle",
          attrs: {
            "colspan": "2"
          }
        }, [_vm._v("Periode Of Service")])]), _c('tr', [_c('th', {
          staticClass: "text-center align-middle"
        }, [_vm._v("Dari")]), _c('th', {
          staticClass: "text-center align-middle"
        }, [_vm._v("Sampai")])])]), _c('tbody', _vm._l((_vm$user35 = _vm.user) === null || _vm$user35 === void 0 ? void 0 : _vm$user35.sail_experience, function (state, index) {
          var _state$ship_name, _state$owner, _state$flag, _state$area, _state$position_id, _state$no_number_comp, _state$date_join, _state$date_end;
          return _c('tr', {
            key: index
          }, [_c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(index + 1))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s((_state$ship_name = state === null || state === void 0 ? void 0 : state.ship_name) !== null && _state$ship_name !== void 0 ? _state$ship_name : '-')), _c('br'), _c('small', {
            staticStyle: {
              "color": "gray"
            }
          }, [_vm._v(_vm._s((_state$owner = state === null || state === void 0 ? void 0 : state.owner) !== null && _state$owner !== void 0 ? _state$owner : '-'))])]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s((_state$flag = state === null || state === void 0 ? void 0 : state.flag) !== null && _state$flag !== void 0 ? _state$flag : '-')), _c('br'), _c('small', {
            staticStyle: {
              "color": "gray"
            }
          }, [_vm._v(_vm._s((_state$area = state === null || state === void 0 ? void 0 : state.area) !== null && _state$area !== void 0 ? _state$area : '-'))])]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s((_state$position_id = state === null || state === void 0 ? void 0 : state.position_id) !== null && _state$position_id !== void 0 ? _state$position_id : '-'))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s((_state$no_number_comp = state === null || state === void 0 ? void 0 : state.no_number_company) !== null && _state$no_number_comp !== void 0 ? _state$no_number_comp : '-'))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s((_state$date_join = state === null || state === void 0 ? void 0 : state.date_join) !== null && _state$date_join !== void 0 ? _state$date_join : '-'))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s((_state$date_end = state === null || state === void 0 ? void 0 : state.date_end) !== null && _state$date_end !== void 0 ? _state$date_end : '-'))])]);
        }), 0)])];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_vm._v("ORGANISASI")])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$user36;
        return [_c('table', {
          staticClass: "table table-striped mb-0"
        }, [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-center"
        }, [_vm._v("Nama Organisasi")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Jabatan")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Tanggal Bergabung")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Tanggal Selesai")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Notes")])])]), _c('tbody', _vm._l((_vm$user36 = _vm.user) === null || _vm$user36 === void 0 ? void 0 : _vm$user36.organization, function (state, index) {
          return _c('tr', {
            key: index
          }, [_c('td', [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.nama_organisasi))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.posisi) + " "), _c('br'), _c('b-badge', {
            attrs: {
              "variant": "primary"
            }
          }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.tempat))])], 1), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.durasi_awal))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.durasi_akhir))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v("-")])]);
        }), 0)])];
      },
      proxy: true
    }])
  })], 2)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }